import formsSlice from 'modules/form/reducer';

export default {
  resetForm: formsSlice.actions.resetForm,
  upsertForm: formsSlice.actions.upsertForm,
  upsertFormMany: formsSlice.actions.upsertFormMany,
  resetVCForm: formsSlice.actions.resetVCForm,
};
